/**
 * @file: OutStockPc.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 业务数据管理中心-出库管理
 */
import request from '@/utils/request'

/**
 * 小程序-获取今日出库食品列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appletOutTodayListGet(data) {
  return request({
    type: 'biz',
    url: 'applet/out/today/list/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据管理中心-食安大数据分析-出库分析-顶部数据统计(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockAnalyseHeadGet(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/analyse/head/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据管理中心-食安大数据分析-食安大数据分析首页-食品出库月度趋势(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockAnalyseMonthTrendGet(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/analyse/month/trend/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据管理中心-食安大数据分析-出库分析-出库报表-导出全部数据(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockAnalysePageAllExport(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/analyse/page/all/export',
    method: 'post',
    data
  })
}

/**
 * 业务数据管理中心-食安大数据分析-出库分析-出库分页报表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockAnalysePageGet(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/analyse/page/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据管理中心-食安大数据分析-出库分析-出库报表-选择导出数据(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockAnalysePageOptionExport(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/analyse/page/option/export',
    method: 'post',
    data
  })
}

/**
 * 批量删除/删除出库历史记录(qiuyanping)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/batch/delete',
    method: 'post',
    data
  })
}

/**
 * 出库详情(qiuyanping)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockGet(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/get',
    method: 'post',
    data
  })
}

/**
 * 食品出库详情 食品出库页面选择对应的食品，返回食品详情以及食品的库存列表（qiuyanping）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockHouseGet(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/house/get',
    method: 'post',
    data
  })
}

/**
 * 食品出库 点击食品出库按钮，搜索食品出库列表（qiuyanping）(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockHouseList(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/house/list',
    method: 'post',
    data
  })
}

/**
 * 出库历史记录(qiuyanping)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockList(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/list',
    method: 'post',
    data
  })
}

/**
 * 单件快出/批量出库出库操作接口（qiuyanping）(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOutStockUpdate(data) {
  return request({
    type: 'biz',
    url: 'pc/out/stock/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/OutStockPc.js